import type { GeneratedSchemaField } from '@cli-types/core-engine/add-field.js'
import type { PromptFieldOptions } from '@cli-types/next-adapter/commands.js'
import { derivePlaceholderFromLabel } from './derive-placeholder-from-label.js'

export function applyDerivedFieldDefaults(
  field: GeneratedSchemaField,
  type: string,
  options: PromptFieldOptions
): void {
  if (!options.derivePlaceholder) {
    return
  }

  const record = field as unknown as Record<string, unknown>
  if (typeof record.placeholder === 'string' && record.placeholder.trim()) {
    return
  }

  const label = typeof record.label === 'string' ? record.label : ''
  const placeholder = derivePlaceholderFromLabel(type, label)
  if (placeholder) {
    record.placeholder = placeholder
  }
}
